export const selectIsLoading = store => store.loading.isLoading;
